"use server";

import { checkHoneypot, checkSubmissionTime, verifyTurnstile } from "@/lib/antispam";
import { getContactInboxEmail } from "@/lib/contact-inbox";
import { Resend } from "resend";

export async function submitContact(prevState, formData) {
	// Inicializar Resend dentro de la función
	const resend = new Resend(process.env.RESEND_API_KEY);

	try {
		// Anti-bot: honeypot y tiempo mínimo (trampa silenciosa)
		if (!checkHoneypot(formData) || !checkSubmissionTime(formData)) {
			return {
				success: true,
				message: "¡Mensaje enviado! Te responderemos lo antes posible.",
			};
		}

		// Anti-bot: Cloudflare Turnstile
		if (!(await verifyTurnstile(formData))) {
			return {
				success: false,
				error: "Verificación de seguridad fallida. Recarga la página e inténtalo de nuevo.",
			};
		}

		const name = formData.get("name");
		const email = formData.get("email");
		const reason = formData.get("reason");
		const message = formData.get("message");
		const acceptPrivacy = formData.get("acceptPrivacy");

		// Validaciones básicas
		if (!name || !email || !message) {
			return {
				success: false,
				error: "Por favor, completa todos los campos obligatorios.",
			};
		}

		if (!acceptPrivacy) {
			return {
				success: false,
				error: "Debes aceptar la política de privacidad para continuar.",
			};
		}

		// Validar formato de email
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			return {
				success: false,
				error: "Por favor, introduce un email válido.",
			};
		}

		// Mapear razón a texto legible
		const reasonLabels = {
			"varios-locales": "Varios locales / Mayor volumen",
			"dudas": "Dudas sobre el servicio",
			"otro": "Otro motivo",
		};
		const reasonText = reasonLabels[reason] || reason || "No especificado";

		// Preparar el contenido del email
		const emailContent = `
Nuevo mensaje de contacto en Kaizen Feedback

═══════════════════════════════════════════════════

👤 DATOS DE CONTACTO
─────────────────────
• Nombre: ${name}
• Email: ${email}
• Motivo: ${reasonText}

💬 MENSAJE
─────────────────────
${message}

═══════════════════════════════════════════════════

Responder a: ${email}

═══════════════════════════════════════════════════
`;

		// Enviar email usando Resend
		// TODO: Cambiar a "Kaizen Feedback <noreply@kaizenfeedback.com>" cuando el dominio esté verificado
		const { data, error } = await resend.emails.send({
			from: "Kaizen Feedback <onboarding@resend.dev>",
			to: [getContactInboxEmail()],
			replyTo: email,
			subject: `[Contacto] ${reasonText} - ${name}`,
			text: emailContent,
		});

		if (error) {
			console.error("Resend error:", error);
			return {
				success: false,
				error: "Ha ocurrido un error al enviar el mensaje. Por favor, inténtalo de nuevo.",
			};
		}

		return {
			success: true,
			message: "¡Mensaje enviado! Te responderemos lo antes posible.",
		};
	} catch (error) {
		console.error("Contact submission error:", error);
		return {
			success: false,
			error: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
		};
	}
}
